module.exports = __webpack_public_path__ + "img/delete.d681da31.png";